import { TypographyProps } from './typography.props';

export const TypographyPresets: TypographyProps = {
  variant: 'p2',
  whiteSpace: 'inherit',
};
